var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentEmojiMovieCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-emoji:movie-camera"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_ii_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.65234 13.3804H18.8733V18.771H7.65234V13.3804Z",
    fill: "#41364E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.65234 13.3804H18.8733V18.771H7.65234V13.3804Z",
    fill: "url(#paint0_radial_434_3251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.65234 13.3804H18.8733V18.771H7.65234V13.3804Z",
    fill: "url(#paint1_radial_434_3251)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.4258 18.0249H23.4877V26.4474H20.4258V18.0249Z",
    fill: "url(#paint2_linear_434_3251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.4258 18.0249H23.4877V26.4474H20.4258V18.0249Z",
    fill: "url(#paint3_linear_434_3251)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_iii_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.03125 18.2263C5.03125 17.6793 5.24855 17.1547 5.63534 16.7679C6.02214 16.3811 6.54674 16.1638 7.09375 16.1638H19.2278C19.7748 16.1638 20.2994 16.3811 20.6862 16.7679C21.073 17.1547 21.2903 17.6793 21.2903 18.2263V26.2448C21.2903 26.7918 21.073 27.3164 20.6862 27.7032C20.2994 28.09 19.7748 28.3073 19.2278 28.3073H7.09375C6.54674 28.3073 6.02214 28.09 5.63534 27.7032C5.24855 27.3164 5.03125 26.7918 5.03125 26.2448V18.2263Z",
    fill: "url(#paint4_linear_434_3251)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    filter: "url(#filter2_ii_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.52148 23.2749C7.52148 23.1257 7.58075 22.9826 7.68624 22.8772C7.79173 22.7717 7.9348 22.7124 8.08398 22.7124H18.238C18.3872 22.7124 18.5303 22.7717 18.6358 22.8772C18.7413 22.9826 18.8005 23.1257 18.8005 23.2749V25.8849C18.8005 25.9588 18.786 26.0319 18.7577 26.1002C18.7295 26.1684 18.688 26.2304 18.6358 26.2826C18.5836 26.3349 18.5216 26.3763 18.4533 26.4046C18.3851 26.4329 18.3119 26.4474 18.238 26.4474H8.08398C8.01012 26.4474 7.93697 26.4329 7.86872 26.4046C7.80048 26.3763 7.73847 26.3349 7.68624 26.2826C7.634 26.2304 7.59257 26.1684 7.5643 26.1002C7.53603 26.0319 7.52148 25.9588 7.52148 25.8849V23.2749Z",
    fill: "url(#paint5_linear_434_3251)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    filter: "url(#filter3_d_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11.5227 24.5797C11.5227 24.8681 11.4081 25.1447 11.2041 25.3487C11.0002 25.5526 10.7236 25.6672 10.4352 25.6672C10.1467 25.6672 9.87012 25.5526 9.66618 25.3487C9.46223 25.1447 9.34766 24.8681 9.34766 24.5797C9.34766 24.2913 9.46223 24.0147 9.66618 23.8107C9.87012 23.6068 10.1467 23.4922 10.4352 23.4922C10.7236 23.4922 11.0002 23.6068 11.2041 23.8107C11.4081 24.0147 11.5227 24.2913 11.5227 24.5797Z",
    fill: "url(#paint6_radial_434_3251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.5227 24.5797C11.5227 24.8681 11.4081 25.1447 11.2041 25.3487C11.0002 25.5526 10.7236 25.6672 10.4352 25.6672C10.1467 25.6672 9.87012 25.5526 9.66618 25.3487C9.46223 25.1447 9.34766 24.8681 9.34766 24.5797C9.34766 24.2913 9.46223 24.0147 9.66618 23.8107C9.87012 23.6068 10.1467 23.4922 10.4352 23.4922C10.7236 23.4922 11.0002 23.6068 11.2041 23.8107C11.4081 24.0147 11.5227 24.2913 11.5227 24.5797Z",
    fill: "url(#paint7_radial_434_3251)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    filter: "url(#filter4_di_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.1602 24.5835C14.1602 24.2178 14.4564 23.9207 14.823 23.9207H16.3098C16.4856 23.9207 16.6542 23.9905 16.7785 24.1148C16.9028 24.2391 16.9727 24.4077 16.9727 24.5835C16.9727 24.7593 16.9028 24.9278 16.7785 25.0521C16.6542 25.1764 16.4856 25.2463 16.3098 25.2463H14.823C14.6472 25.2463 14.4786 25.1764 14.3543 25.0521C14.23 24.9278 14.1602 24.7593 14.1602 24.5835Z",
    fill: "url(#paint8_linear_434_3251)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    filter: "url(#filter5_ii_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M28.2742 16.7046C28.2743 16.6103 28.2507 16.5175 28.2055 16.4347C28.1603 16.3519 28.0951 16.2818 28.0157 16.2308C27.9364 16.1799 27.8455 16.1497 27.7514 16.143C27.6573 16.1363 27.5631 16.1535 27.4773 16.1928L23.4883 18.0237V26.4471L27.4802 28.2546C27.5658 28.2933 27.6597 28.3099 27.7534 28.303C27.8471 28.296 27.9375 28.2657 28.0165 28.2148C28.0954 28.1639 28.1604 28.094 28.2054 28.0116C28.2504 27.9291 28.2741 27.8367 28.2742 27.7428V16.7037V16.7046Z",
    fill: "url(#paint9_linear_434_3251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M28.2742 16.7046C28.2743 16.6103 28.2507 16.5175 28.2055 16.4347C28.1603 16.3519 28.0951 16.2818 28.0157 16.2308C27.9364 16.1799 27.8455 16.1497 27.7514 16.143C27.6573 16.1363 27.5631 16.1535 27.4773 16.1928L23.4883 18.0237V26.4471L27.4802 28.2546C27.5658 28.2933 27.6597 28.3099 27.7534 28.303C27.8471 28.296 27.9375 28.2657 28.0165 28.2148C28.0954 28.1639 28.1604 28.094 28.2054 28.0116C28.2504 27.9291 28.2741 27.8367 28.2742 27.7428V16.7037V16.7046Z",
    fill: "url(#paint10_linear_434_3251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M28.2742 16.7046C28.2743 16.6103 28.2507 16.5175 28.2055 16.4347C28.1603 16.3519 28.0951 16.2818 28.0157 16.2308C27.9364 16.1799 27.8455 16.1497 27.7514 16.143C27.6573 16.1363 27.5631 16.1535 27.4773 16.1928L23.4883 18.0237V26.4471L27.4802 28.2546C27.5658 28.2933 27.6597 28.3099 27.7534 28.303C27.8471 28.296 27.9375 28.2657 28.0165 28.2148C28.0954 28.1639 28.1604 28.094 28.2054 28.0116C28.2504 27.9291 28.2741 27.8367 28.2742 27.7428V16.7037V16.7046Z",
    fill: "url(#paint11_radial_434_3251)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M2.4082 18.9624H5.03039V21.819H2.4082V18.9624Z",
    fill: "url(#paint12_linear_434_3251)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    filter: "url(#filter6_iii_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M13.4252 10.5173C13.4339 11.1355 13.3197 11.7493 13.0892 12.3231C12.8587 12.8968 12.5164 13.419 12.0823 13.8593C11.6482 14.2996 11.1309 14.6492 10.5605 14.8878C9.99013 15.1265 9.37799 15.2494 8.75969 15.2494C8.14138 15.2494 7.52924 15.1265 6.95885 14.8878C6.38845 14.6492 5.87117 14.2996 5.43707 13.8593C5.00297 13.419 4.66071 12.8968 4.43018 12.3231C4.19966 11.7493 4.08545 11.1355 4.09422 10.5173C4.1116 9.29138 4.61078 8.12157 5.48384 7.2608C6.35689 6.40003 7.53366 5.91748 8.75969 5.91748C9.98572 5.91748 11.1625 6.40003 12.0355 7.2608C12.9086 8.12157 13.4078 9.29138 13.4252 10.5173Z",
    fill: "#231C2A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    filter: "url(#filter7_f_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M12.7648 10.4845C12.7648 11.547 12.3427 12.5661 11.5913 13.3174C10.84 14.0688 9.82092 14.4909 8.75836 14.4909C7.69579 14.4909 6.67675 14.0688 5.9254 13.3174C5.17406 12.5661 4.75195 11.547 4.75195 10.4845C4.75195 9.42201 5.17401 8.40309 5.92526 7.65183C6.67652 6.90057 7.69545 6.47852 8.75789 6.47852C9.82033 6.47852 10.8393 6.90057 11.5905 7.65183C12.3418 8.40309 12.7648 9.42201 12.7648 10.4845Z",
    fill: "url(#paint13_linear_434_3251)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    filter: "url(#filter8_f_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M12.9991 10.3673C12.9991 11.4609 12.5647 12.5098 11.7914 13.2831C11.018 14.0564 9.96919 14.4909 8.87555 14.4909C7.7819 14.4909 6.73305 14.0564 5.95973 13.2831C5.1864 12.5098 4.75195 11.4609 4.75195 10.3673C4.75195 9.27375 5.18635 8.22501 5.95959 7.45178C6.73282 6.67854 7.78156 6.24414 8.87508 6.24414C9.9686 6.24414 11.0173 6.67854 11.7906 7.45178C12.5638 8.22501 12.9991 9.27375 12.9991 10.3673Z",
    fill: "url(#paint14_radial_434_3251)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    filter: "url(#filter9_iii_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M23.5638 10.5173C23.5726 11.1355 23.4584 11.7493 23.2279 12.3231C22.9973 12.8968 22.6551 13.419 22.221 13.8593C21.7869 14.2996 21.2696 14.6492 20.6992 14.8878C20.1288 15.1265 19.5167 15.2494 18.8984 15.2494C18.2801 15.2494 17.6679 15.1265 17.0975 14.8878C16.5271 14.6492 16.0098 14.2996 15.5757 13.8593C15.1416 13.419 14.7994 12.8968 14.5689 12.3231C14.3383 11.7493 14.2241 11.1355 14.2329 10.5173C14.2503 9.29138 14.7495 8.12157 15.6225 7.2608C16.4956 6.40003 17.6723 5.91748 18.8984 5.91748C20.1244 5.91748 21.3012 6.40003 22.1742 7.2608C23.0473 8.12157 23.5465 9.29138 23.5638 10.5173Z",
    fill: "#231C2A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    filter: "url(#filter10_f_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M22.9054 10.4844C22.9054 11.547 22.4833 12.566 21.7319 13.3174C20.9806 14.0687 19.9615 14.4908 18.899 14.4908C17.8364 14.4908 16.8174 14.0687 16.066 13.3174C15.3147 12.566 14.8926 11.547 14.8926 10.4844C14.8926 9.42187 15.3147 8.40282 16.066 7.65148C16.8174 6.90013 17.8364 6.47803 18.899 6.47803C19.9615 6.47803 20.9806 6.90013 21.7319 7.65148C22.4833 8.40282 22.9054 9.42187 22.9054 10.4844Z",
    fill: "url(#paint15_linear_434_3251)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    filter: "url(#filter11_f_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M23.1398 10.3672C23.1398 11.4609 22.7053 12.5097 21.932 13.2831C21.1587 14.0564 20.1098 14.4908 19.0162 14.4908C17.9225 14.4908 16.8737 14.0564 16.1004 13.2831C15.327 12.5097 14.8926 11.4609 14.8926 10.3672C14.8926 9.2736 15.327 8.22475 16.1004 7.45143C16.8737 6.6781 17.9225 6.24365 19.0162 6.24365C20.1098 6.24365 21.1587 6.6781 21.932 7.45143C22.7053 8.22475 23.1398 9.2736 23.1398 10.3672Z",
    fill: "url(#paint16_radial_434_3251)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    filter: "url(#filter12_di_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M9.70805 10.4844C9.70805 10.736 9.60809 10.9773 9.43016 11.1553C9.25224 11.3332 9.01092 11.4331 8.7593 11.4331C8.50767 11.4331 8.26635 11.3332 8.08843 11.1553C7.9105 10.9773 7.81055 10.736 7.81055 10.4844C7.81055 10.2328 7.9105 9.99145 8.08843 9.81353C8.26635 9.6356 8.50767 9.53564 8.7593 9.53564C9.01092 9.53564 9.25224 9.6356 9.43016 9.81353C9.60809 9.99145 9.70805 10.2328 9.70805 10.4844Z",
    fill: "url(#paint17_radial_434_3251)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    filter: "url(#filter13_di_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M19.7491 10.4844C19.7491 10.736 19.6491 10.9773 19.4712 11.1553C19.2933 11.3332 19.0519 11.4331 18.8003 11.4331C18.5487 11.4331 18.3074 11.3332 18.1294 11.1553C17.9515 10.9773 17.8516 10.736 17.8516 10.4844C17.8516 10.2328 17.9515 9.99145 18.1294 9.81353C18.3074 9.6356 18.5487 9.53564 18.8003 9.53564C19.0519 9.53564 19.2933 9.6356 19.4712 9.81353C19.6491 9.99145 19.7491 10.2328 19.7491 10.4844Z",
    fill: "url(#paint18_radial_434_3251)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M2.05711 18.4531C2.06377 18.2702 2.14112 18.097 2.27286 17.97C2.40461 17.843 2.5805 17.772 2.76352 17.772C2.94653 17.772 3.12242 17.843 3.25417 17.97C3.38592 18.097 3.46326 18.2702 3.46992 18.4531V22.3269C3.47338 22.4218 3.45767 22.5164 3.42373 22.6052C3.38979 22.6939 3.33831 22.7749 3.27237 22.8432C3.20643 22.9116 3.12739 22.966 3.03996 23.0032C2.95253 23.0403 2.85851 23.0595 2.76352 23.0595C2.66852 23.0595 2.5745 23.0403 2.48707 23.0032C2.39964 22.966 2.3206 22.9116 2.25466 22.8432C2.18872 22.7749 2.13725 22.6939 2.1033 22.6052C2.06936 22.5164 2.05365 22.4218 2.05711 22.3269V18.4522V18.4531Z",
    fill: "url(#paint19_linear_434_3251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M2.05711 18.4531C2.06377 18.2702 2.14112 18.097 2.27286 17.97C2.40461 17.843 2.5805 17.772 2.76352 17.772C2.94653 17.772 3.12242 17.843 3.25417 17.97C3.38592 18.097 3.46326 18.2702 3.46992 18.4531V22.3269C3.47338 22.4218 3.45767 22.5164 3.42373 22.6052C3.38979 22.6939 3.33831 22.7749 3.27237 22.8432C3.20643 22.9116 3.12739 22.966 3.03996 23.0032C2.95253 23.0403 2.85851 23.0595 2.76352 23.0595C2.66852 23.0595 2.5745 23.0403 2.48707 23.0032C2.39964 22.966 2.3206 22.9116 2.25466 22.8432C2.18872 22.7749 2.13725 22.6939 2.1033 22.6052C2.06936 22.5164 2.05365 22.4218 2.05711 22.3269V18.4522V18.4531Z",
    fill: "url(#paint20_radial_434_3251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M2.05711 18.4531C2.06377 18.2702 2.14112 18.097 2.27286 17.97C2.40461 17.843 2.5805 17.772 2.76352 17.772C2.94653 17.772 3.12242 17.843 3.25417 17.97C3.38592 18.097 3.46326 18.2702 3.46992 18.4531V22.3269C3.47338 22.4218 3.45767 22.5164 3.42373 22.6052C3.38979 22.6939 3.33831 22.7749 3.27237 22.8432C3.20643 22.9116 3.12739 22.966 3.03996 23.0032C2.95253 23.0403 2.85851 23.0595 2.76352 23.0595C2.66852 23.0595 2.5745 23.0403 2.48707 23.0032C2.39964 22.966 2.3206 22.9116 2.25466 22.8432C2.18872 22.7749 2.13725 22.6939 2.1033 22.6052C2.06936 22.5164 2.05365 22.4218 2.05711 22.3269V18.4522V18.4531Z",
    fill: "url(#paint21_radial_434_3251)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    filter: "url(#filter14_f_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M16.508 24.2283H14.7718C14.6465 24.2283 14.5449 24.3298 14.5449 24.4551C14.5449 24.5804 14.6465 24.682 14.7718 24.682H16.508C16.6333 24.682 16.7349 24.5804 16.7349 24.4551C16.7349 24.3298 16.6333 24.2283 16.508 24.2283Z",
    fill: "url(#paint22_linear_434_3251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M16.508 24.2283H14.7718C14.6465 24.2283 14.5449 24.3298 14.5449 24.4551C14.5449 24.5804 14.6465 24.682 14.7718 24.682H16.508C16.6333 24.682 16.7349 24.5804 16.7349 24.4551C16.7349 24.3298 16.6333 24.2283 16.508 24.2283Z",
    fill: "url(#paint23_radial_434_3251)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    filter: "url(#filter15_f_434_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M19.7224 16.9402H6.91992C6.40215 16.9402 5.98242 17.3599 5.98242 17.8777V26.3152C5.98242 26.833 6.40215 27.2527 6.91992 27.2527H19.7224C20.2402 27.2527 20.6599 26.833 20.6599 26.3152V17.8777C20.6599 17.3599 20.2402 16.9402 19.7224 16.9402Z",
    stroke: "url(#paint24_linear_434_3251)",
    strokeWidth: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_434_3251",
    x: 7.15234,
    y: 13.3804,
    width: 12.2207,
    height: 5.89062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.156863 0 0 0 0 0.223529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.290196 0 0 0 0 0.356863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3251",
    result: "effect2_innerShadow_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iii_434_3251",
    x: 4.53125,
    y: 15.6638,
    width: 17.2598,
    height: 13.1436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.152941 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.152941 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3251",
    result: "effect2_innerShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.286275 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_434_3251",
    result: "effect3_innerShadow_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_434_3251",
    x: 7.52148,
    y: 22.5124,
    width: 11.4793,
    height: 4.13511,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654902 0 0 0 0 0.564706 0 0 0 0 0.745098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682353 0 0 0 0 0.631373 0 0 0 0 0.717647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3251",
    result: "effect2_innerShadow_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_434_3251",
    x: 8.59766,
    y: 23.2422,
    width: 3.17578,
    height: 3.17505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.619608 0 0 0 0 0.505882 0 0 0 0 0.662745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_434_3251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_434_3251",
    x: 13.4102,
    y: 23.6707,
    width: 3.8125,
    height: 2.32568,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.529412 0 0 0 0 0.682353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_434_3251",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.329412 0 0 0 0 0.203922 0 0 0 0 0.427451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_434_3251",
    x: 23.4883,
    y: 15.6416,
    width: 5.28516,
    height: 13.1628,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.168627 0 0 0 0 0.258824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.392157 0 0 0 0 0.27451 0 0 0 0 0.494118 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3251",
    result: "effect2_innerShadow_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_iii_434_3251",
    x: 3.59375,
    y: 4.91748,
    width: 9.83203,
    height: 10.8318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.129412 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.113725 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3251",
    result: "effect2_innerShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0.301961 0 0 0 0 0.388235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_434_3251",
    result: "effect3_innerShadow_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_434_3251",
    x: 4.25195,
    y: 5.97852,
    width: 9.01367,
    height: 9.01245,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_434_3251",
    x: 4.25195,
    y: 5.74414,
    width: 9.24805,
    height: 9.24683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_iii_434_3251",
    x: 13.7324,
    y: 4.91748,
    width: 9.83203,
    height: 10.8318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.129412 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.113725 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3251",
    result: "effect2_innerShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0.301961 0 0 0 0 0.388235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_434_3251",
    result: "effect3_innerShadow_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_434_3251",
    x: 14.3926,
    y: 5.97803,
    width: 9.01367,
    height: 9.0127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_434_3251",
    x: 14.3926,
    y: 5.74365,
    width: 9.24805,
    height: 9.24707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_di_434_3251",
    x: 7.06055,
    y: 9.28564,
    width: 2.89844,
    height: 2.89746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.203922 0 0 0 0 0.141176 0 0 0 0 0.262745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_434_3251",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.701961 0 0 0 0 0.682353 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_di_434_3251",
    x: 17.1016,
    y: 9.28564,
    width: 2.89844,
    height: 2.89746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.203922 0 0 0 0 0.141176 0 0 0 0 0.262745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_434_3251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_434_3251",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.701961 0 0 0 0 0.682353 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_434_3251",
    x: 14.0449,
    y: 23.7283,
    width: 3.18945,
    height: 1.45386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_434_3251"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_434_3251",
    x: 4.73242,
    y: 15.6902,
    width: 17.1777,
    height: 12.8125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_434_3251"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_434_3251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.32297 13.3804) rotate(52.6713) scale(2.56063 5.44892)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#2B2035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2035",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_434_3251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8178 13.8056) rotate(124.129) scale(3.18529 6.63024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332146",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_434_3251",
    x1: 21.9567,
    y1: 18.0249,
    x2: 21.9567,
    y2: 23.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99979B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABA2B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_434_3251",
    x1: 21.9567,
    y1: 22.2362,
    x2: 21.9567,
    y2: 26.4474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9673B6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9673B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_434_3251",
    x1: 18.9616,
    y1: 16.6185,
    x2: 10.0263,
    y2: 28.1029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#524064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453B50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_434_3251",
    x1: 13.1605,
    y1: 22.7124,
    x2: 13.1605,
    y2: 26.4474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA1BC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_434_3251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0932 23.6632) rotate(115.763) scale(2.22427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F72B49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F32D95"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_434_3251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9555 24.1475) rotate(132.31) scale(0.772515 0.80204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FF576F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF576F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_434_3251",
    x1: 14.2886,
    y1: 24.9388,
    x2: 16.8517,
    y2: 24.9388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#3F344B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#443553"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_434_3251",
    x1: 25.8817,
    y1: 17.8193,
    x2: 25.8817,
    y2: 28.1028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362A43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#412756"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_434_3251",
    x1: 28.2742,
    y1: 27.2824,
    x2: 27.4286,
    y2: 27.2824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2A4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_434_3251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.1027 21.0415) rotate(90) scale(5.36133 0.636994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#696171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696171",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_434_3251",
    x1: 3.71883,
    y1: 19.5183,
    x2: 3.71883,
    y2: 21.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746F7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D6DAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_434_3251",
    x1: 11.8423,
    y1: 8.82977,
    x2: 5.65383,
    y2: 13.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F3F61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#443A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_434_3251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.06977 11.272) rotate(-42.797) scale(5.08571 5.24798)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#443A4F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_434_3251",
    x1: 21.9838,
    y1: 8.82975,
    x2: 15.7954,
    y2: 13.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F3F61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#443A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_434_3251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2104 11.2729) rotate(-42.797) scale(5.08571 5.24798)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#443A4F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6075"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_434_3251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.7593 9.92377) rotate(90) scale(1.69922 1.54206)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9984AF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_434_3251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8003 9.92377) rotate(90) scale(1.69922 1.54206)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9984AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_434_3251",
    x1: 2.05711,
    y1: 20.72,
    x2: 3.46992,
    y2: 20.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281837"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_434_3251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.76305 19.8547) rotate(90) scale(3.07617 0.568425)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#443B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#443B4F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_434_3251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.76305 19.7234) rotate(90) scale(3.31055 1.32514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#523968",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523968"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_434_3251",
    x1: 16.8371,
    y1: 24.4551,
    x2: 14.2899,
    y2: 24.4551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675F73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_434_3251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6993 24.5358) rotate(180) scale(0.496106 0.778461)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#756C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#685F73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_434_3251",
    x1: 21.7615,
    y1: 16.2605,
    x2: 16.5452,
    y2: 23.7736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#695E75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#695E75",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEmojiMovieCamera);
export default __webpack_public_path__ + "static/media/fluent-emoji_movie-camera.9575e197a4b71ad7f21d7e0510120c06.svg";
export { ForwardRef as ReactComponent };